import react from "react"
import Hero from "../Components/Hero/Hero.jsx"
import Slider from "../Components/Slider/Slider.jsx";
import  "./CSS/Home.css";
/*import Popular from "../Components/Popular/Popular.jsx"
import Offers from "../Components/Offers/Offers.jsx"
import NewCollection from "../Components/NewCollection/NewCollection.jsx"
import NewsLetter from "../Components/NewsLetter/NewsLetter.jsx"*/

const Home=()=>{
    return(
        <div className="home">
         <Hero/>
		 {/* <Slider/>*/}
         {/*<Popular/>
         <Offers/>
         <NewCollection/>*/}
        {/*} <Popular/>
         <Offers/>
         <NewCollection/>
         <NewsLetter/>*/}
        </div>
    )
}
export default Home